<template>
    <WindowedForm v-model="form" />
</template>
<script>

    import LanguageService from "../../services/LanguageService.js";
    import WindowedForm from "../globalUiElements/WindowedForm.vue";
    import { createForm } from "../../utils/FormUtils.js";
    import { l } from "../../utils/LocalizationUtils.js";
    import { getAppLocaleOptions } from "../../locales/utils/localeUtils.js";


    export default {
        components: {
            WindowedForm
        },
        props: {
            entry : { type: Object, default: null }
        },
        data() {
            return {
                form: createForm({

                    title: {
                        label: "Edit Language ${v.ietfLanguageTag}",
                        entry: this.entry
                    },

                    action: LanguageService.updateLanguage,

                    fieldDefs: [
                        {
                            key: "_id",
                            type: "Hidden",
                            value: this.entry._id,
                        },
                        {
                            key: "name",
                            type: "Text",
                            label: "Name",
                            value: this.entry.name,
                            required: true,
                        },
                        {
                            key: "priority",
                            type: "Hidden",
                            value: this.entry.priority,
                        },
                        {
                            key: "showInCMS",
                            type: "Checkbox",
                            label: "Show in CMS",
                            value: this.entry.showInCMS || false,
                        },
                        {
                            key: "showInApp",
                            type: "Checkbox",
                            label: "Show in App",
                            value: this.entry.showInApp || false,
                        },
                        {
                            key: "translationsMandatory",
                            type: "Checkbox",
                            label: "Content has to be translated into this locale",
                            value: this.entry.translationsMandatory || false,
                        },
                        {
                            key: "fallbackLocale",
                            type: "Select",
                            label: "Fallback locale if translations are missing",
                            options: [
                                { value: null, text: "No fallback (non-translated elements are hidden)" },
                                ...getAppLocaleOptions(),
                            ],
                            value: typeof this.entry.fallbackLocale !== "undefined" ? this.entry.fallbackLocale : null,
                        },
                    ],

                    submitLabel: "Save",

                    submitted: entry => {
                        this.$root.$emit("success", l("Changes to language \"${v.name}\" saved.", entry));
                        this.$emit("editedEntry");
                    },

                    cancelled: () => {
                        this.$emit("cancel");
                    }
                })
            }
        }
    }
</script>